import { Heading } from '@radix-ui/themes';

export default Heading;
